import React from "react";
// import img from '../../../assets/Images/logo-images/l'
import imgrd2 from '../../../assets/Images/r-d/rd_9.jpg'

const Research_Development_Second = () => {
  return (
    <section className="w-full bg-white py-14 md:py-20 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">

        {/* Heading */}
        {/* <div className="text-center mb-12 md:mb-16">
          <h2 className="text-xl sm:text-2xl md:text-4xl font-bold text-[#355931] leading-snug uppercase">
            Research & Development Excellence at Nutralike
          </h2>

          <div className="w-24 h-[3px] bg-[#A9C32C] mx-auto mt-5 rounded-full"></div>

          <p className="mt-8 text-gray-600 text-sm sm:text-base md:text-lg leading-relaxed max-w-5xl mx-auto">
           Innovative Nutraceutical, Effervescent, Sports Nutrition & Cosmetic Formulation Development Backed by Science,
           Stability & Regulatory Precision.
          </p>
        </div> */}

        {/* Main Content */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-14 items-center">

          {/* Left Side Image */}
          <div className="relative group">

            <img
              src={imgrd2}
              alt="Research Development"
              className="w-full h-[280px] sm:h-[420px] object-cover rounded-[40px]"
            />
          </div>

          {/* Right Side Content */}
          <div>
            {/* Small Heading */}
            <p className="text-sm sm:text-base tracking-[2px] text-[#A9C32C] mb-3">
              Research & Development
            </p>

            {/* Main Heading */}
            <h3 className="text-3xl sm:text-4xl md:text-5xl font-serif text-[#355931] leading-tight">
              R&D{" "}
              
              <span className="bg-gradient-to-r from-[#355931] via-[#6b8f4e] to-[#A9C32C] bg-clip-text text-transparent">
                Overview
              </span>
            </h3>

            <div className="w-20 h-[3px] bg-[#A9C32C] mt-4 mb-7 rounded-full"></div>

            <div className="space-y-5 text-gray-600 text-sm sm:text-base md:text-lg leading-relaxed max-w-2xl">
              
              <p>
                At Nutralike, Research & Development drives every innovation we bring to the health and wellness industry. 
                Our advanced R&D infrastructure combines scientific expertise, modern analytical technologies, 
                and market-driven formulation strategies to develop high-performance nutraceutical and cosmetic products.
                With 12+ years of manufacturing expertise and 500+ formulations developed, we provide complete formulation 
                support for startups, private label brands, exporters, and global wellness companies.
              </p>

              <p>
                Our integrated facility includes:<br></br>
                - Advanced formulation laboratories<br></br>
                - Analytical & microbiology testing labs<br></br>
                - Stability chambers<br></br>
                - Pilot-scale manufacturing setup<br></br>
                - Regulatory documentation support
              </p>


            </div>

            {/* Button */}
            {/* <button className="mt-8 inline-flex items-center border-1 border-[#355931] gap-2 hover:bg-[#355931] text-[#355931] hover:text-white px-8 py-3.5 rounded-full text-sm md:text-base font-semibold transition-all duration-300 shadow-lg hover:scale-105">
              Read More

              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="w-5 h-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth={2}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M19 9l-7 7-7-7"
                />
              </svg>
            </button> */}
          </div>

        </div>
      </div>
    </section>
  );
};

export default Research_Development_Second;